import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logOut } from '../../Store/userSlice';
import { isUpscContext } from '../../utils/trackResolver';

/**
 * Bridges the axios 401 interceptor (which lives outside React) to a SOFT logout.
 *
 * The interceptor has already cleared auth storage and shown a toast; this listener
 * drops the in-memory Redux user and does a React-Router navigation to the public
 * home — replacing the old hard `window.location.href = '/'` page reload that made
 * session expiry jarring (the "loud logout" during demos). Renders nothing.
 */
const SessionExpiryListener = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const onExpired = () => {
      dispatch(logOut());
      // UPSC context (subdomain / app / /upsc path): keep aspirants on their own
      // login, never the main MarksZen login.
      if (isUpscContext()) {
        navigate('/upsc/signin', { replace: true });
        return;
      }
      // Native app: '/' is the marketing landing — send a logged-out user to the
      // login screen instead. Web keeps the soft-logout-to-home behaviour.
      const isNativeApp =
        typeof window !== 'undefined' && !!window.Capacitor?.isNativePlatform?.();
      navigate(isNativeApp ? '/teacher-login' : '/', { replace: true });
    };
    window.addEventListener('auth:session-expired', onExpired);
    return () => window.removeEventListener('auth:session-expired', onExpired);
  }, [dispatch, navigate]);

  return null;
};

export default SessionExpiryListener;
